import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { StepperService } from "../../../../services/stepper.service";
import { constants } from "../../../../utils/constants";
import { AccountService } from "../../../../services/account.service";
import { IErrorAlert } from "../../../../interfaces/error.interface";
import { TranslatorService } from "../../../../services/translator.service";

import helpers from "../../../../utils/helpers";

@Component({
  selector: "app-admin-data",
  templateUrl: "./admin-data.component.html",
  styleUrls: ["../../../auth.styles.css"],
})
export class AdminDataComponent implements OnInit {
  constants: any = constants;
  helpers: any = helpers;
  invalidRuc: IErrorAlert = { ...constants.alerts.invalidRuc, width: "auto" };
  error: IErrorAlert = null;
  loading: boolean;
  docTypes: any[] = [];
  maxLengthDoc: number;
  form: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    public _account: AccountService,
    public _translator: TranslatorService,
    public _stepper: StepperService
  ) {
    this._stepper.setCurrent(1);
  }

  ngOnInit(): void {
    this.initForm();
    this._translator.getDocTypes().subscribe(
      (docTypes: any) => {
        this.docTypes = docTypes;
        this.loading = false;
      },
      (err) => {
        this.error = { ...err, width: "auto" };
        this.form.controls["docType"].disable();
        this.loading = false;
      }
    );
  }

  onChange(event: any) {
    let control = this.form.controls["docNumber"];
    this.maxLengthDoc = helpers.onChangeDocType(event, control);
  }

  continue() {
    this.error = null;
    this.loading = true;
    this._account.generateToken(this.form.value).subscribe(
      (resp: any) => this._router.navigate(["recover-password/enter-code"]),
      (err: IErrorAlert) => {
        this.error = { ...err, width: "auto" };
        this.loading = false;
      }
    );
  }

  initForm() {
    this.form = this._fb.group({
      ruc: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(11),
        ],
      ],
      docType: ["", [Validators.required]],
      docNumber: [{ value: "", disabled: true }, Validators.required],
    });
    this.form.valueChanges.subscribe((data) => {
      if (this.error?.blocked) {
        this.error = null
      }
    });
    this.helpers.initFormListeners(this.form);
  }

  anyAlert(): boolean {
    return (
      (helpers.invalidControl(this.form.get("ruc")) &&
        !this.form.get("ruc").errors.required) ||
      this.error !== null
    );
  }
}
